module.exports = __webpack_public_path__ + "static/individual2-f64e805884ddeca46f650b5273128347.png";